import { FormDisplayMode } from 'src/enums/database.enum';

export function modalTitle(modalMode: number, section: { show: string; create: string; edit: string }): string {
  let title = '';
  switch (modalMode) {
    case FormDisplayMode.SHOW:
      title = section.show;
      break;
    case FormDisplayMode.CREATE:
      title = section.create;
      break;
    case FormDisplayMode.EDIT:
      title = section.edit;
      break;
    default:
      title = 'Unhandled action';
  }
  return title;
}
